import React from 'react'
import { Box, styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const Shell = styled(Box)({
  minHeight: '100dvh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--ds-canvas)',
  padding: '40px 24px',
})

const Card = styled(Box)({
  maxWidth: 480,
  width: '100%',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0,
})

const Big = styled('div')({
  fontSize: 'clamp(96px, 18vw, 148px)',
  fontWeight: 820,
  letterSpacing: '-0.06em',
  lineHeight: 0.88,
  background: 'var(--ds-gradient-spectrum, linear-gradient(135deg, #ffcf7d, #fea67d, #be9dfd, #01dafe))',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  userSelect: 'none',
  marginBottom: 28,
})

const Title = styled('h1')({
  margin: 0,
  fontSize: 'clamp(20px, 3.5vw, 26px)',
  fontWeight: 740,
  letterSpacing: '-0.03em',
  color: 'var(--ds-ink)',
  marginBottom: 10,
})

const Body = styled('p')({
  margin: 0,
  fontSize: 14.5,
  lineHeight: 1.6,
  color: 'var(--ds-ink-subtle)',
  maxWidth: 320,
  marginBottom: 32,
})

const Actions = styled(Box)({
  display: 'flex',
  gap: 10,
  flexWrap: 'wrap',
  justifyContent: 'center',
})

const Btn = styled('button', {
  shouldForwardProp: (p) => p !== '$primary',
})<{ $primary?: boolean }>(({ $primary }) => ({
  all: 'unset',
  boxSizing: 'border-box',
  height: 40,
  padding: '0 22px',
  borderRadius: 'var(--ds-radius-pill)',
  fontSize: 13.5,
  fontWeight: 640,
  cursor: 'pointer',
  transition: 'opacity 120ms ease, box-shadow 120ms ease',
  ...($primary
    ? {
        background: 'var(--ds-ink)',
        color: 'var(--ds-inverse-ink)',
        '&:hover': { opacity: 0.85 },
      }
    : {
        boxShadow: 'inset 0 0 0 1.5px var(--ds-border-strong)',
        color: 'var(--ds-ink)',
        '&:hover': { boxShadow: 'inset 0 0 0 1.5px var(--ds-ink-muted)' },
      }),
}))

const Mono = styled('div')({
  fontFamily: 'var(--ds-font-mono)',
  fontSize: 11,
  letterSpacing: '0.1em',
  color: 'var(--ds-ink-subtle)',
  marginBottom: 12,
  opacity: 0.5,
})

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <Shell>
      <Card>
        <Big>404</Big>
        <Mono>PAGE NOT FOUND</Mono>
        <Title>This page doesn&rsquo;t exist</Title>
        <Body>
          The link may be broken, the page may have moved, or you might not have access to it.
        </Body>
        <Actions>
          <Btn onClick={() => navigate(-1)}>← Go back</Btn>
          <Btn $primary onClick={() => navigate('/')}>Go home</Btn>
        </Actions>
      </Card>
    </Shell>
  )
}
